/* eslint-disable */
import React from 'react';
import './index.less';
import './index.en.less';

export interface IAIAttackScamProps {
  title?: string;
  image?: string;
  description?: string;
}

const AIAttackScam: React.FunctionComponent<IAIAttackScamProps> = ({
  title,
  image,
  description,
}) => {
  return (
    <div className="ai-attack-scam">
      {title && <h3 className="ai-attack-scam-title">{title}</h3>}
      <div className="ai-attack-scam-card">
        <div className="ai-attack-scam-images">
          {image && (
            <div className="ai-attack-scam-image-wrapper">
              <img src={image} alt="" />
            </div>
          )}
        </div>
        {description && <p className="ai-attack-scam-desc">{description}</p>}
      </div>
    </div>
  );
};

export default React.memo(AIAttackScam);
